import { usStateOptions } from 'components/Dashboard/Filters/FiltersData/LegislationFilters';
import ConfigData from 'config/ConfigData';

export const createTagFilterOption = (array, tagIsNot) => {
  return array.map((tag) => {
    if (tag.selected === 'exclude' && tagIsNot) {
      return { name: tag.value, selected: true, value: tag.value };
    } else if (tag.selected === true && !tagIsNot) {
      return { name: tag.value, selected: true, value: tag.value };
    } else {
      return { name: tag.value, value: tag.value, hidden: true };
    }
  });
};

const InfluenceContactsFilters = [
  {
    name: 'Vocal about a topic',
    pages: ['InfluenceContacts'],
    searchState: 'always',
    filterName: 'topicMatchedKeywordListIds',
    customOrder: 1,
    type: 'topicPickerWithSentiment',
    prefix: 'vocal-about',
    sentiment: null,
    options: [],
    updateFilter: true,
  },
  {
    prefix: 'state',
    name: 'State',
    pages: ['InfluenceContacts'],
    filterName: 'constituency',
    optionSelected: '',
    options: usStateOptions.filter((item) => item.name !== 'US Congress'),
    configHidden: ConfigData?.filters?.state?.configHidden,
    customOrder: 5,
  },
  {
    name: 'Tag',
    pages: ['InfluenceContacts'],
    searchState: 'always',
    filterName: 'tags',
    additionalItemsText: 'tags',
    notUseFromLocalStorage: true,
    customOrder: 6.2,
    prefix: 'tag',
    options: [],
  },
  {
    name: 'Last interaction date',
    pages: ['InfluenceContacts'],
    searchState: 'always',
    filterName: 'lastInteractionDate',
    customOrder: 6.5,
    prefix: 'lastInteraction',
    type: 'lastInteractionDate',
    options: [
      { name: 'In the last 7 days', filterValue: '7', operator: 'days_ago_lt' },
      { name: 'In the last 30 days', filterValue: '30', operator: 'days_ago_lt' },
      { name: 'In the last 90 days', filterValue: '90', operator: 'days_ago_lt' },
      { name: 'In the last 365 days', filterValue: '365', operator: 'days_ago_lt' },
      { name: 'Custom', filterValue: '', operator: 'days_ago_lt', isCustom: true },
    ],
  },
  {
    name: 'Champion status',
    pages: ['InfluenceContacts'],
    searchState: 'always',
    filterName: 'championStatus',
    customOrder: 6.1,
    optionSelected: '',
    options: [
      {
        name: 'Promoter',
      },
      {
        name: 'Detractor',
      },
      {
        name: 'Neutral',
      },
      {
        name: 'No status',
        filterValue: null,
        operator: 'not_exists',
      },
    ],
    prefix: '',
  },
];

export default InfluenceContactsFilters;
